/* eslint-disable react/prop-types */
import { DATA_STATUS, LOADING_PROPERTY_HISTORY } from '@/constants';
import * as dataSelectors from '@/data/data-selectors';
import * as listSelectors from '@/list/list-selectors';
import { PropertyHistory } from '@/property-history';
import * as userSelectors from '@/user/user-selectors';
import { usePropertyDetails } from '@/utils/hooks/data/usePropertyDetails';
import { LoadingPlaceholder } from '@/widgets/components/data-loading-placeholder';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const StyledPropertyHistory = styled(PropertyHistory)`
  min-width: 1000px;
  max-width: 1300px;
  margin: auto;
  min-height: calc(100vh - 200px);

  @media only screen and (max-width: 1480px) {
    margin-left: 30px;
  }
`;

export function PropertyHistoryContent() {
  const { currentProperty, loading: currentPropertyLoading } =
    usePropertyDetails();
  const licenseData = useSelector(dataSelectors.licensesData);
  const isLicensingEnabled = useSelector(listSelectors.isLicensingEnabled);

  const userRights = useSelector(userSelectors.userRights);
  const canViewLicenses = Boolean(userRights?.viewLicense);

  if (currentPropertyLoading) {
    return <LoadingPlaceholder loadingText={LOADING_PROPERTY_HISTORY} />;
  }

  if (!currentProperty) return <div>No data available</div>;

  if (
    canViewLicenses &&
    (!licenseData || DATA_STATUS.inProgress === licenseData)
  ) {
    return <LoadingPlaceholder loadingText={LOADING_PROPERTY_HISTORY} />;
  }

  const isLicenseDataError = typeof licenseData === 'string';

  return (
    <StyledPropertyHistory
      property={currentProperty}
      licenseData={isLicenseDataError ? [] : licenseData || []}
      isLicensingEnabled={isLicensingEnabled}
    />
  );
}
